import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Attribute for scrollable containers that should reset to top on route change */
export const APP_SCROLL_ROOT_ATTR = 'data-app-scroll-root';

const scrollToTop = () => {
  window.scrollTo(0, 0);
  if (document.documentElement) document.documentElement.scrollTop = 0;
  if (document.body) document.body.scrollTop = 0;
  const roots = document.querySelectorAll(`[${APP_SCROLL_ROOT_ATTR}]`);
  roots.forEach((el) => {
    el.scrollTop = 0;
  });
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToTop();
    // Run again after paint so mobile browsers and dynamic content respect it
    const id = requestAnimationFrame(scrollToTop);
    return () => cancelAnimationFrame(id);
  }, [pathname]);

  return null;
};

export default ScrollToTop;